import { isLanguage, Language } from './Localized.ts';
import { useState } from 'react';
import { createLocalStorageLanguageAccessor } from './LocalStorageLanguageAccessor.ts';

export const [getLocalStorageLanguage, setLocalStorageLanguage] =
    createLocalStorageLanguageAccessor('dp_language');

const [getLegacyLocalStorageLanguage] = createLocalStorageLanguageAccessor(
    'parkingabo_language',
);

export function getBrowserLanguage(
    discardEn: boolean = false,
): Language | null {
    const languages = [
        ...navigator.languages,
        navigator.language,
        (navigator as Navigator & { userLanguage?: string }).userLanguage,
    ].filter((lang): lang is string => lang != null);

    return (
        languages
            .map(lang => lang.split('-')[0].toLowerCase())
            .find(lang => isLanguage(lang, discardEn)) ?? null
    );
}

export function useSystemLanguage() {
    const localStorageLanguage = getLocalStorageLanguage();
    const legacyLocalStorageLanguage = getLegacyLocalStorageLanguage();

    if (localStorageLanguage === null && legacyLocalStorageLanguage !== null) {
        setLocalStorageLanguage(legacyLocalStorageLanguage);
    }

    const [language, setInternalLanguage] = useState(
        localStorageLanguage ??
            legacyLocalStorageLanguage ??
            getBrowserLanguage() ??
            Language.DE,
    );

    const setLanguage = (lang: Language) => {
        setLocalStorageLanguage(lang);
        setInternalLanguage(lang);
    };

    return {
        language,
        setLanguage,
    };
}
